import ProjectPictureApi from '~/common/api/zeiterfassungServerApi/ProjectPictureApi';
import ReactImageUploading from 'react-images-uploading';
import { Box, Button, Image } from '@chakra-ui/react';
import useTranslate from '~/common/utils/translate';
import React, { useState, useEffect } from 'react';
import { CloseIcon } from '@chakra-ui/icons';

interface ProjectPictureProps {
  initialImage: string | null;
  projectId: number;
}

const ProjectPicture: React.FC<ProjectPictureProps> = ({
  initialImage,
  projectId,
}) => {
  const translate = useTranslate();
  const [image, setImage] = useState<string | null>(initialImage);
  const { mutate: updateProjectPicture } =
    ProjectPictureApi.hooks.useUpdateProjectPictureMutation();
  const { mutate: deleteProjectPicture } =
    ProjectPictureApi.hooks.useDeleteProjectPictureMutation();

  useEffect(() => {
    if (initialImage) {
      setImage(initialImage);
    }
  }, [initialImage]);

  const handleImageChange = (imageList: any) => {
    if (imageList && imageList.length > 0) {
      const newImage = imageList[0].dataURL;
      const pictureFile = imageList[0].file;
      updateProjectPicture({
        project: { id: projectId },
        image: pictureFile,
      });
      setImage(newImage);
    }
  };

  const handleDelete = () => {
    deleteProjectPicture({ id: projectId });
    setImage(null);
  };

  return (
    <Box position="relative" w="full" h="full">
      <Box position="relative" w="full" h="full" overflow="hidden">
        {image ? (
          <Image src={image} />
        ) : (
          <Box
            w="full"
            h="full"
            display="flex"
            alignItems="center"
            justifyContent="center"
            border="2px dashed gray"
          >
            <span>
              {translate('project.createEditProject.projectPicture.noPicText')}
            </span>
          </Box>
        )}
        {image && (
          <Box
            position="absolute"
            top={2}
            right={3}
            _hover={{ cursor: 'pointer' }}
            zIndex={2}
            onClick={handleDelete}
          >
            <CloseIcon color="red.600" />
          </Box>
        )}
      </Box>
      <ReactImageUploading
        value={[]}
        onChange={handleImageChange}
        multiple={false}
        acceptType={['jpg', 'jpeg']}
      >
        {({ onImageUpload }) => (
          <Button onClick={onImageUpload} variant="solid" w="full" mt={4}>
            {translate('project.createEditProject.projectPicture.upload')}
          </Button>
        )}
      </ReactImageUploading>
    </Box>
  );
};

export default ProjectPicture;
